import 'select2/dist/js/select2.min';

$(document).ready(() => {
  if ($('select').length > 0) {
    $('select').select2({
      // remove search bar
      minimumResultsForSearch: Infinity,
    });
  }
});
